export enum VitalTypeIDEnum {
  Height = 1,
  Weight = 2,
  BMI = 3,
  CalculateWeeksPassedForWeightTracker = 99,
}
